import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import './Features.scss';

const Features = () => {
  const { t } = useTranslation();
  
  const features = [
    {
      image: 'fabric-type-cotton.png',
      title: t('features.cotton.title'),
      description: t('features.cotton.description')
    },
    {
      image: 'fabric-type-linen.png',
      title: t('features.linen.title'),
      description: t('features.linen.description')
    },
    {
      image: 'fabric-type-twill.png',
      title: t('features.twill.title'),
      description: t('features.twill.description')
    }
  ];

  return (
    <section id="about" className="features-section">
      <Container>
        <div className="section-header text-center mb-4" data-aos="fade-down">
          <h2>{t('features.title')}</h2>
          <p className="section-description">
            {t('features.description')}
          </p>
        </div>
        <Row>
          {features.map((features, index) => (
            <Col md={4} key={index}>
              <div className="feature-card" data-aos="fade-up" data-aos-delay={index * 100}>
                <div className="feature-image">
                  <img src={require(`../../assets/images/${features.image}`)} alt={features.title} />
                  <div className="feature-overlay">
                    <h3>{features.title}</h3>
                    <p>{features.description}</p>
                  </div>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default Features;